import { useGenerateAndAddAIModuleMutation } from "entities/pages/mutations/useGenerateAndAddAIModuleMutation";
import { invalidateModuleListByBrandPageQuery } from "entities/pages/queries/useModuleListByBrandPageQuery";
import { useState } from "react";
import InlinePromptInput from "shared/components/InlinePromptInput";
import { usePageModules } from "../../context";
import { StyledError } from "./styled";

export default function GenerateAIModule({
  onModuleGenerated,
}: {
  onModuleGenerated: (moduleId: string) => void;
}) {
  const { brandId, pageId } = usePageModules();
  const [prompt, setPrompt] = useState("");

  const {
    mutate: generateModule,
    isPending: isGenerating,
    error,
  } = useGenerateAndAddAIModuleMutation();

  const handleGenerate = () => {
    if (prompt.trim() && !isGenerating) {
      generateModule(
        {
          brandId,
          pageId,
          prompt,
          order: 0,
        },
        {
          onSuccess: async (data) => {
            await invalidateModuleListByBrandPageQuery(brandId, pageId);
            onModuleGenerated(data.moduleId || "");
            setPrompt("");
          },
        },
      );
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleGenerate();
    }
  };

  return (
    <div>
      <InlinePromptInput
        value={prompt}
        isLoading={isGenerating}
        onChange={(e) => setPrompt(e.target.value)}
        onGenerate={handleGenerate}
        onKeyDown={handleKeyDown}
        placeholder="Describe the game module you want to create."
      />
      <StyledError>
        {error ? <span>{error.message}</span> : <span>&nbsp;</span>}
      </StyledError>
    </div>
  );
}
